import {
  ComponentRef,
  Directive,
  ElementRef,
  inject,
  Input,
  OnChanges,
  Renderer2,
  ViewContainerRef,
} from '@angular/core';
import { LoadButtonSpinnerComponent } from '@qaroni-shared/components/load-button-spinner/load-button-spinner.component';

@Directive({
  selector: '[qaroniLoadButton]',
  standalone: true,
})
export class LoadButtonDirective implements OnChanges {
  @Input() isLoading: boolean = false;

  private el = inject(ElementRef);
  private renderer = inject(Renderer2);
  private viewContainerRef = inject(ViewContainerRef);

  private natEl = this.el.nativeElement;
  private spinnerRef: ComponentRef<LoadButtonSpinnerComponent> | null = null;

  ngOnChanges() {
    if (this.isLoading) {
      this.renderer.setAttribute(this.natEl, 'disabled', 'true');
      this.addClasses(this.natEl, 'relative !text-transparent');
      this.addSpinner();
    } else {
      this.renderer.removeAttribute(this.natEl, 'disabled');
      this.removeClasses(this.natEl, 'relative !text-transparent');
      this.removeSpinner();
    }
  }

  private addSpinner() {
    if (!this.spinnerRef) {
      this.spinnerRef = this.viewContainerRef.createComponent(
        LoadButtonSpinnerComponent
      );

      this.renderer.appendChild(
        this.natEl,
        this.spinnerRef.location.nativeElement
      );
    }
  }

  private addClasses(el: HTMLElement, names: string) {
    names.split(' ').forEach(name => {
      this.renderer.addClass(el, name);
    });
  }

  private removeSpinner() {
    if (this.spinnerRef) {
      this.spinnerRef.destroy();
      this.spinnerRef = null;
    }
  }

  private removeClasses(element: HTMLElement, classNames: string) {
    classNames.split(' ').forEach(className => {
      this.renderer.removeClass(element, className);
    });
  }
}
